export enum UserTypeEnum {
  AjutoarePrimarie = 'Ajutoare de incalzire_Primarii',
  AjutoareAdmin = 'Ajutoare de incalzire_Intern',
  Visitor = ''
}
